/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Interview_InvitationsInputs */

const en_admin_statistics_interview_invitations = /** @type {(inputs: Admin_Statistics_Interview_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview invitations`)
};

const de_admin_statistics_interview_invitations = /** @type {(inputs: Admin_Statistics_Interview_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesprächseinladungen`)
};

/**
* | output |
* | --- |
* | "Interview invitations" |
*
* @param {Admin_Statistics_Interview_InvitationsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_interview_invitations = /** @type {((inputs?: Admin_Statistics_Interview_InvitationsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Interview_InvitationsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_interview_invitations(inputs)
	return en_admin_statistics_interview_invitations(inputs)
});